let UTILS = require("./utils.js");
var v9419;
var vO300 = {};
module.exports.loadImg = p12083 => {
  if (!vO300[p12083]) {
    vO300[p12083] = new Image();
    vO300[p12083].onload = () => vO300[p12083].isReady = true;
    vO300[p12083].src = p12083;
  }
  return vO300[p12083];
};
module.exports.patchImg = (p12084, p12085) => {
  vO300[p12084] = new Image();
  vO300[p12084].onload = () => vO300[p12084].isReady = true;
  vO300[p12084].src = p12085;
  return vO300[p12084];
};
module.exports.customGUI = (p12086, p12087, p12088, p12089, p12090, p12091, p12092) => {
  p12086.save(1);
  p12086.globalAlpha = p12087.o || 0;
  var v9420 = (p12087.x || 0) / 100 * p12088 - (p12087.w || 0) / 2;
  var v9421 = (p12087.y || 0) / 100 * p12089 - (p12087.h || 0) / 2;
  p12086.fillStyle = p12087.c || "#ff0000";
  if (p12087.t == 0) {
    p12086.fillRect(v9420, v9421, p12087.w || 0, p12087.h || 0);
  }
  if (p12087.t == 1) {
    var vLS38 = "";
    if (p12087.vt == 0) {
      vLS38 = p12087.v || "Text";
    } else if (p12087.vt == 1) {
      vLS38 = p12087.v;
      if (p12090) {
        if (p12092.playerVals.indexOf(p12087.v) > -1) {
          vLS38 = p12090[p12087.v];
        } else {
          vLS38 = p12090.custVals[p12087.v] || 0;
        }
      }
    } else if (p12087.vt == 2) {
      vLS38 = 0;
      if (p12091 && p12091.globalVals[p12087.v + ""] != null) {
        vLS38 = p12091.globalVals[p12087.v + ""];
      }
    }
    var v9422 = p12087.f || 10;
    p12086.font = v9422 + "px GameFont";
    var v9423 = Math.round(p12086.measureText(vLS38).width / 2);
    p12086.fillText(vLS38, v9420 - v9423, v9421 + v9422 / 2);
  }
  if (p12087.t == 2) {
    var v9424 = UTILS.userAssetsUrl("/" + (p12087.s || "").replace(/[^\d]/g, "") + "/texture.png");
    var v9425 = module.exports.loadImg(v9424);
    if (v9425.isReady) {
      p12086.drawImage(v9425, v9420, v9421, p12087.w || 0, p12087.h || 0);
    }
  }
  p12086.restore(-1);
};
module.exports.updateCustomGUI = (p12093, p12094, p12095, p12096, p12097, p12098, p12099, p12100, p12101, p12102) => {
  if (p12099 && p12099.length) {
    for (var v9426 = p12100 ? p12099 : [...p12099].sort((p12103, p12104) => (p12103.z || 0) - (p12104.z || 0)), vLN01533 = 0; vLN01533 < v9426.length; ++vLN01533) {
      v9419 = v9426[vLN01533];
      if (v9419.o && !v9419.nv) {
        module.exports.customGUI(p12093, v9419, p12094, p12095, p12096, p12097, p12098, p12101, p12102);
      }
    }
  }
};
module.exports.GIF = function () {
  function f1520(p12105, p12106) {
    var v9427;
    var v9428;
    var v9429;
    var v9430;
    var v9431;
    var v9432;
    var v9433;
    var v9434;
    var v9435;
    var v9436;
    var v9437;
    var v9438;
    v9429 = v9428 = 0;
    v9434 = [];
    v9430 = 1 << p12105;
    v9431 = v9430 + 1;
    v9432 = p12105 + 1;
    v9433 = false;
    while (!v9433) {
      v9436 = v9435;
      v9435 = 0;
      v9427 = 0;
      for (; v9427 < v9432; v9427++) {
        if (p12106[v9429 >> 3] & 1 << (v9429 & 7)) {
          v9435 |= 1 << v9427;
        }
        v9429++;
      }
      if (v9435 === v9430) {
        v9434 = [];
        v9432 = p12105 + 1;
        v9427 = 0;
        for (; v9427 < v9430; v9427++) {
          v9434[v9427] = [v9427];
        }
        v9434[v9430] = [];
        v9434[v9431] = null;
      } else {
        if (v9435 === v9431) {
          v9433 = true;
          return;
        }
        if (v9435 >= v9434.length) {
          v9434.push(v9434[v9436].concat(v9434[v9436][0]));
        } else if (v9436 !== v9430) {
          v9434.push(v9434[v9436].concat(v9434[v9435][0]));
        }
        v9437 = v9434[v9435];
        v9438 = v9437.length;
        v9427 = 0;
        for (; v9427 < v9438; v9427++) {
          v9470[v9428++] = v9437[v9427];
        }
        if (v9434.length === 1 << v9432 && v9432 < 12) {
          v9432++;
        }
      }
    }
  }
  function f1521(p12107) {
    var vA529 = [];
    for (var vLN01534 = 0; vLN01534 < p12107; vLN01534++) {
      vA529.push([v9466.data[v9466.pos++], v9466.data[v9466.pos++], v9466.data[v9466.pos++]]);
    }
    return vA529;
  }
  function f1522() {
    var v9439;
    v9466.pos += 6;
    vO302.width = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    vO302.height = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    v9439 = v9466.data[v9466.pos++];
    vO302.colorRes = (v9439 & 112) >> 4;
    vO302.globalColourCount = 1 << (v9439 & 7) + 1;
    vO302.bgColourIndex = v9466.data[v9466.pos++];
    v9466.pos++;
    if (v9439 & 128) {
      vO302.globalColourTable = f1521(vO302.globalColourCount);
    }
    requestAnimationFrame(f1530, 0);
  }
  function f1523() {
    v9466.pos += 1;
    if (v9466.getString(8) === "NETSCAPE") {
      v9466.pos += 8;
    } else {
      v9466.pos += 3;
      v9466.readSubBlocks();
    }
  }
  function f1524() {
    var v9440;
    v9466.pos++;
    v9440 = v9466.data[v9466.pos++];
    vO302.disposalMethod = (v9440 & 28) >> 2;
    vO302.transparencyGiven = !!(v9440 & 1);
    vO302.delayTime = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    vO302.transparencyIndex = v9466.data[v9466.pos++];
    v9466.pos++;
  }
  function f1525() {
    var v9441;
    var v9442;
    var v9443;
    v9441 = function (p12108) {
      var v9444;
      var v9445;
      var v9446;
      var v9447;
      v9444 = v9469 / p12108;
      v9445 = 0;
      if (v9467 !== v9469) {
        v9468 = new Uint8Array(v9469);
        v9467 = v9469;
      }
      v9446 = 0;
      for (; v9446 < 4; v9446++) {
        for (v9447 = vA530[v9446]; v9447 < v9444; v9447 += vA531[v9446]) {
          v9468.set(v9470.subArray(v9445, v9445 + p12108), v9447 * p12108);
          v9445 += p12108;
        }
      }
    };
    v9442 = {};
    vO302.frames.push(v9442);
    v9442.disposalMethod = vO302.disposalMethod;
    v9442.time = vO302.length;
    v9442.delay = vO302.delayTime * 10;
    vO302.length += v9442.delay;
    v9442.transparencyIndex = vO302.transparencyGiven ? vO302.transparencyIndex : undefined;
    v9442.leftPos = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    v9442.topPos = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    v9442.width = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    v9442.height = v9466.data[v9466.pos++] + (v9466.data[v9466.pos++] << 8);
    v9443 = v9466.data[v9466.pos++];
    v9442.localColourTableFlag = !!(v9443 & 128);
    if (v9442.localColourTableFlag) {
      v9442.localColourTable = f1521(1 << (v9443 & 7) + 1);
    }
    if (v9469 !== v9442.width * v9442.height) {
      v9470 = new Uint8Array(v9442.width * v9442.height);
      v9469 = v9442.width * v9442.height;
    }
    f1520(v9466.data[v9466.pos++], v9466.readSubBlocksB());
    if (v9443 & 64) {
      v9442.interlaced = true;
      v9441(v9442.width);
    } else {
      v9442.interlaced = false;
    }
    f1526(v9442);
  }
  function f1526(v9458) {
    var v9448;
    var v9449;
    var v9450;
    var v9451;
    var v9452;
    var v9453;
    var v9454;
    var v9455;
    var v9456;
    var v9457;
    var v9458;
    var v9459;
    v9458.image = document.createElement("canvas");
    v9458.image.width = vO302.width;
    v9458.image.height = vO302.height;
    v9458.image.ctx = v9458.image.getContext("2d");
    v9448 = v9458.localColourTableFlag ? v9458.localColourTable : vO302.globalColourTable;
    if (vO302.lastFrame === null) {
      vO302.lastFrame = v9458;
    }
    v9453 = vO302.lastFrame.disposalMethod === 2 || vO302.lastFrame.disposalMethod === 3;
    if (!v9453) {
      v9458.image.ctx.drawImage(vO302.lastFrame.image, 0, 0, vO302.width, vO302.height);
    }
    v9449 = v9458.image.ctx.getImageData(v9458.leftPos, v9458.topPos, v9458.width, v9458.height);
    v9459 = v9458.transparencyIndex;
    v9450 = v9449.data;
    v9456 = v9458.interlaced ? v9468 : v9470;
    v9451 = v9456.length;
    v9452 = 0;
    v9454 = 0;
    for (; v9454 < v9451; v9454++) {
      v9455 = v9456[v9454];
      v9457 = v9448[v9455];
      if (v9459 === v9455) {
        if (v9453) {
          v9450[v9452 + 3] = 0;
          v9452 += 4;
        } else {
          v9452 += 4;
        }
      } else {
        v9450[v9452++] = v9457[0];
        v9450[v9452++] = v9457[1];
        v9450[v9452++] = v9457[2];
        v9450[v9452++] = 255;
      }
    }
    v9458.image.ctx.putImageData(v9449, v9458.leftPos, v9458.topPos);
    vO302.lastFrame = v9458;
    if (!vO302.waitTillDone && typeof vO302.onload == "function") {
      f1532();
    }
  }
  function f1527() {
    vO302.loading = false;
    vO302.frameCount = vO302.frames.length;
    vO302.lastFrame = null;
    v9466 = undefined;
    vO302.complete = true;
    vO302.disposalMethod = undefined;
    vO302.transparencyGiven = undefined;
    vO302.delayTime = undefined;
    vO302.transparencyIndex = undefined;
    vO302.waitTillDone = undefined;
    v9470 = undefined;
    v9468 = undefined;
    v9469 = undefined;
    v9468 = undefined;
    vO302.currentFrame = 0;
    if (vO302.frames.length > 0) {
      vO302.image = vO302.frames[0].image;
    }
    f1532();
    if (typeof vO302.onloadall == "function") {
      vO302.onloadall.bind(vO302)({
        type: "loadall",
        path: [vO302]
      });
    }
    if (vO302.playOnLoad) {
      vO302.play();
    }
  }
  function f1528() {
    f1527();
    if (typeof vO302.cancelCallback == "function") {
      vO302.cancelCallback.bind(vO302)({
        type: "canceled",
        path: [vO302]
      });
    }
  }
  function f1529() {
    const v9460 = v9466.data[v9466.pos++];
    if (v9460 === vO301.GCExt) {
      f1524();
    } else if (v9460 === vO301.COMMENT) {
      vO302.comment += v9466.readSubBlocks();
    } else if (v9460 === vO301.APPExt) {
      f1523();
    } else {
      if (v9460 === vO301.UNKNOWN) {
        v9466.pos += 13;
      }
      v9466.readSubBlocks();
    }
  }
  function f1530() {
    if (vO302.cancel !== undefined && vO302.cancel === true) {
      f1528();
      return;
    }
    const v9461 = v9466.data[v9466.pos++];
    if (v9461 !== vO301.IMAGE) {
      if (v9461 === vO301.EOF) {
        f1527();
        return;
      }
      f1529();
    } else {
      f1525();
      if (vO302.firstFrameOnly) {
        f1527();
        return;
      }
    }
    if (typeof vO302.onprogress == "function") {
      vO302.onprogress({
        bytesRead: v9466.pos,
        totalBytes: v9466.data.length,
        frame: vO302.frames.length
      });
    }
    requestAnimationFrame(f1530, 0);
  }
  function f1531(p12110) {
    if (typeof vO302.onerror == "function") {
      vO302.onerror.bind(this)({
        type: p12110,
        path: [this]
      });
    }
    vO302.onload = vO302.onerror = undefined;
    vO302.loading = false;
  }
  function f1532() {
    vO302.currentFrame = 0;
    vO302.nextFrameAt = vO302.lastFrameAt = new Date().valueOf();
    if (typeof vO302.onload == "function") {
      vO302.onload.bind(vO302)({
        type: "load",
        path: [vO302]
      });
    }
    vO302.onerror = vO302.onload = undefined;
  }
  function f1533(p12111) {
    v9466 = new f1537(p12111);
    f1522();
  }
  function f1534(p12112) {
    var v9462 = new XMLHttpRequest();
    v9462.responseType = "arraybuffer";
    v9462.onload = function (p12113) {
      if (p12113.target.status === 404) {
        f1531("File not found");
      } else if (p12113.target.status >= 200 && p12113.target.status < 300) {
        f1533(v9462.response);
      } else {
        f1531("Loading error : " + p12113.target.status);
      }
    };
    v9462.open("GET", p12112, true);
    v9462.send();
    v9462.onerror = function (p12114) {
      f1531("File error");
    };
    this.src = p12112;
    this.loading = true;
  }
  function f1535() {
    vO302.paused = true;
    vO302.playing = false;
    clearTimeout(v9465);
  }
  function f1536() {
    var v9463;
    var v9464;
    if (vO302.playSpeed === 0) {
      vO302.pause();
      return;
    } else {
      if (vO302.playSpeed < 0) {
        vO302.currentFrame -= 1;
        if (vO302.currentFrame < 0) {
          vO302.currentFrame = vO302.frames.length - 1;
        }
        v9464 = vO302.currentFrame;
        v9464 -= 1;
        if (v9464 < 0) {
          v9464 = vO302.frames.length - 1;
        }
        v9463 = -vO302.frames[v9464].delay * 1 / vO302.playSpeed;
      } else {
        vO302.currentFrame += 1;
        vO302.currentFrame %= vO302.frames.length;
        v9463 = vO302.frames[vO302.currentFrame].delay * 1 / vO302.playSpeed;
      }
      vO302.image = vO302.frames[vO302.currentFrame].image;
      v9465 = requestAnimationFrame(f1536, v9463);
      return;
    }
  }
  var v9465;
  var v9466;
  var v9467;
  var v9468;
  var v9469;
  var v9470;
  var vA530 = [0, 4, 2, 1];
  var vA531 = [8, 8, 4, 2];
  const vO301 = {
    GCExt: 249,
    COMMENT: 254,
    APPExt: 255,
    UNKNOWN: 1,
    IMAGE: 44,
    EOF: 59,
    EXT: 33
  };
  function f1537(p12115) {
    this.data = new Uint8ClampedArray(p12115);
    this.pos = 0;
    var v9471 = this.data.length;
    this.getString = function (p12116) {
      var vLS39 = "";
      for (; p12116--;) {
        vLS39 += String.fromCharCode(this.data[this.pos++]);
      }
      return vLS39;
    };
    this.readSubBlocks = function () {
      var v9472;
      var v9473;
      var vLS40 = "";
      do {
        for (v9473 = v9472 = this.data[this.pos++]; v9473--;) {
          vLS40 += String.fromCharCode(this.data[this.pos++]);
        }
      } while (v9472 !== 0 && this.pos < v9471);
      return vLS40;
    };
    this.readSubBlocksB = function () {
      var v9474;
      var v9475;
      var vA532 = [];
      do {
        for (v9475 = v9474 = this.data[this.pos++]; v9475--;) {
          vA532.push(this.data[this.pos++]);
        }
      } while (v9474 !== 0 && this.pos < v9471);
      return vA532;
    };
  }
  var vO302 = {
    onload: null,
    onerror: null,
    onprogress: null,
    onloadall: null,
    paused: false,
    playing: false,
    waitTillDone: true,
    loading: false,
    firstFrameOnly: false,
    width: null,
    height: null,
    frames: [],
    comment: "",
    length: 0,
    currentFrame: 0,
    frameCount: 0,
    playSpeed: 1,
    lastFrame: null,
    image: null,
    playOnLoad: true,
    load: f1534,
    cancel: function f1538(p12117) {
      return !vO302.complete && (vO302.cancelCallback = p12117, vO302.cancel = true, true);
    },
    play: function f1539() {
      if (!vO302.playing) {
        vO302.paused = false;
        vO302.playing = true;
        f1536();
      }
    },
    pause: f1535,
    seek: function f1540(p12118) {
      clearTimeout(v9465);
      if (p12118 < 0) {
        p12118 = 0;
      }
      p12118 *= 1000;
      p12118 %= vO302.length;
      for (var vLN01535 = 0; p12118 > vO302.frames[vLN01535].time + vO302.frames[vLN01535].delay && vLN01535 < vO302.frames.length;) {
        vLN01535 += 1;
      }
      vO302.currentFrame = vLN01535;
      if (vO302.playing) {
        f1536();
      } else {
        vO302.image = vO302.frames[vO302.currentFrame].image;
      }
    },
    seekFrame: function f1541(p12119) {
      clearTimeout(v9465);
      vO302.currentFrame = p12119 % vO302.frames.length;
      if (vO302.playing) {
        f1536();
      } else {
        vO302.image = vO302.frames[vO302.currentFrame].image;
      }
    },
    togglePlay: function f1542() {
      if (vO302.paused || !vO302.playing) {
        vO302.play();
      } else {
        vO302.pause();
      }
    }
  };
  return vO302;
};